// File config styles chung cho báo giá
export const baseFont = "'Myriad Pro Light','Myriad Pro','Helvetica Neue',Arial,sans-serif";

// Font sizes - responsive
export const fontSizes = {
  table: "1.25rem", // 12px on desktop, responsive trên mobile
  tableHeader: "2rem", // 13px on desktop
  title: "1.3125rem", // 21px on desktop
  subTitle: "0.875rem", // 14px on desktop
  small: "0.625rem", // 10px on desktop
};

// Responsive breakpoints
export const breakpoints = {
  mobile: "@media (max-width: 768px)",
  tablet: "@media (max-width: 1024px)",
};

// Cell styles
export const tableCell = {
  border: "1px solid #000",
  padding: "8px",
  textAlign: "center",
  fontSize: fontSizes.table,
  fontWeight: "normal",
  verticalAlign: "middle",
  background: "#ffffffff",
};


export const tableTitle = {
  border: "1px solid #000",
  padding: "8px",
  textAlign: "center",
  fontSize: fontSizes.title,
  fontWeight: "bold",
  verticalAlign: "middle",
  background: "#FDE9D9",
};



// Input styles
export const tableInput = {
  border: "1px solid #000",
  width: "100%",
  outline: "none",
  fontSize: fontSizes.table,
  fontFamily: baseFont,
};

// Textarea styles
export const tableTextarea = {
  width: "100%",
  border: "none",
  outline: "none",
  fontSize: fontSizes.table,
  padding: "6px",
  wordWrap: "break-word",
  overflowWrap: "break-word",
  resize: "none",
  fontFamily: baseFont,
  minHeight: "30px",
  height: "auto",
  overflow: "hidden",
  lineHeight: "1.4",
};

// Header styles
export const tableHeader = {
  border: "1px solid #000",
  padding: "8px",
  textAlign: "center",
  fontSize: fontSizes.tableHeader,
  fontWeight: "bold",
  verticalAlign: "middle",
  background: "#FDE9D9",
};

// Wrapper styles cho tables để scroll trên mobile
export const tableWrapper = {
  width: "100%",
  overflowX: "auto",
  overflowY: "visible",
  WebkitOverflowScrolling: "touch",
};

// Container styles responsive
export const containerStyles = {
  width: "210mm",
  maxWidth: "100%",
  margin: "0 auto",
  padding: "15mm",
  fontFamily: baseFont,
  fontSize: fontSizes.table,
  lineHeight: "1.4",
  color: "#000",
  background: "white",
};

// Mobile styles
export const mobileStyles = `
  @media (max-width: 768px) {
    .quote-document {
      width: 100% !important;
      max-width: 100% !important;
      padding: 10px !important;
      font-size: 0.875rem !important;
    }
    
    .quote-table {
      font-size: 0.75rem !important;
      min-width: 600px !important;
    }
    
    .quote-table th,
    .quote-table td {
      font-size: 0.75rem !important;
      padding: 4px 2px !important;
    }
    
    .quote-table input,
    .quote-table textarea {
      font-size: 0.75rem !important;
      padding: 2px !important;
    }
  }
  
  @media (max-width: 480px) {
    .quote-document {
      padding: 5px !important;
      font-size: 0.8rem !important;
    }
    
    .quote-table {
      font-size: 0.7rem !important;
    }
    
    .quote-table th,
    .quote-table td {
      font-size: 0.7rem !important;
      padding: 3px 1px !important;
    }
  }
`;
